import React, {useEffect, useRef, useState} from "react";
import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {DateInput} from "@progress/kendo-react-dateinputs";
import {Button} from "@progress/kendo-react-buttons";
import {Checkbox} from "@progress/kendo-react-inputs";
import {Label} from "@progress/kendo-react-labels";
import Loader from "../Loader";
import {useFormik} from "formik";
import {
    formatDateToString,
    semcastAxios,
    showErrorToastMessage,
    showSuccessToastMessage
} from "../../../Utils/Common";
import {
    ACTIVATION_ID_PLACE_HOLDER,
    FTP_SETTINGS,
    FTP_STRING,
    IDENTITY_REPORT_ACTIVATION_API,
    IDENTITY_REPORT_TRACKING_PIXEL_API,
    SEGMENT_ID_PLACE_HOLDER,
    S3_STRING,
    SUCCESS_STATUS, IDENTITY_REPORT_IDX_PIXEL_API
} from "../../../api/constants";
import { getFTPSettings } from "../../../actions/OnBoardingActions";
import "./IdentityActivation.css";
import DatePicker from 'rsuite/DatePicker';

const IdentityActivation = (props) => {
    let dateRangeStyle = "";
    const dateStartRef = React.useRef();
    const dateEndRef = React.useRef();
    const [dateStartValue, setDateStartValue] = React.useState(null);
    const [dateEndValue, setDateEndValue] = React.useState(null);
    const [consumerDatesWarningMsg, setConsumerDatesWarningMsg] = useState("");
    const [visible, setVisible] = useState(props.visible);
    const [isLoaded, setIsLoaded] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [ftpSettingsId, setFtpSettingsId] = useState(0);
    const [allSavedSettings, setAllSavedSettings] = useState([]);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [defaultStartDate, setDefaultStartDate] = useState(
        (props.Identity.profileFormik ?
            new Date(props.Identity.profileFormik.values.selectedSegments[0].createdAt) : null)
    );

    const [currentConnection, setCurrentConnection] = useState(
        {text: '', id: 0}
    );

    const [currentScope, setCurrentScope] = useState({text: "All", id: "A"})

    const selectedSegment = props.Identity.profileFormik?.values?.selectedSegments[0];

    // current connection (default / chosen) details
    const [connection, setConnection] = useState(
        {
            id: 0,
            connectionName: '',
            protocol: 'ftps',
            host: '',
            port: '',
            destinationDir: '',
            delimiter: '',
            transferMode: 'Passive',
            username: '',
            password: '',
        }
    );
    const [tagId, setTagId] = useState(0);

    useEffect(() => {
        const getSettings = async() => {
            try {
                const settings = await getFTPSettings();
                if (settings && settings.data.length) {
                    setAllSavedSettings(settings.data);
                    const setting = settings.data[settings.data.length - 1];
                    if (setting) {
                        setCurrentConnection({
                            ...currentConnection,
                            ['text']: setting.connection_name,
                            ['id']: setting.id,
                            ['protocol']: setting.transfer_protocol
                        });
                    } else {
                        setCurrentConnection({text: '', id: 0});
                    }
                    setConnection(setting);
                    setFtpSettingsId(setting.id);
                }
            } catch {
                showErrorToastMessage("Could not access Connection information.");
            } finally {
                setIsLoaded(true);
            }
        }
        getSettings();
    }, []);

    useEffect(() => {
    }, [props.segName]);

    useEffect(() => {
        if (props.Identity.profileFormik.values &&
            props.Identity.profileFormik.values.selectedSegments[0] &&
            props.Identity.profileFormik.values.selectedSegments[0].createdAt) {
            const createdAtDate = new Date(props.Identity.profileFormik.values.selectedSegments[0].createdAt);
            const formattedDate =
                createdAtDate.toLocaleString("default", {year: "numeric"}) + "-" +
                createdAtDate.toLocaleString("default", {month: "2-digit"})  + "-" +
                createdAtDate.toLocaleString("default", {day: "2-digit"});
            setStartDate(formattedDate);
        }
    }, [])

    useEffect(()  => {
        // if (startDate !== "" && startDate !== null && currentConnection.id > 0) {
        //     setDisableSubmit(false);
        // }
        if (dateStartValue !== null && currentConnection.id > 0 && currentScope) {
            setDisableSubmit(false);
        }else{
            setDisableSubmit(true);
        }
    }, [dateStartValue, currentConnection.id, currentScope]);

    useEffect(() => {
        if(selectedSegment.objectType.toLowerCase() !== "idx-tag"){
           if(selectedSegment.subType.toLowerCase() === "consumer" || selectedSegment.subType.toLowerCase() === "idx-consumer"){
               setCurrentScope({text: "Consumer", id: "C"});
           }else if(selectedSegment.subType.toLowerCase() === "business"|| selectedSegment.subType.toLowerCase() === "idx-business"){
               setCurrentScope({text: "Business", id: "B"})
           }
        }
    }, []);

    function getAllIds(obj) {
        let ids = [];

        // Helper function to recursively extract ids
        function extractIds(currentObj) {
            // Add the current object's id to the ids array
            if (currentObj.id !== undefined) {
                ids.push(currentObj.id);
            }

            // Check if the current object has children and recurse
            if (Array.isArray(currentObj.children)) {
                currentObj.children.forEach(child => extractIds(child));
            }
        }

        // Start the extraction with the main object
        extractIds(obj);

        return ids;
    }

    useEffect(()=>{
        const selected = props.Identity.profileFormik.values.selectedSegments[0];
        if (!selected) return;

        if (selected.objectType === "IDX-Tag") {
            setTagId(selected.id);
            return;
        }

        if (selected.objectType === "Segment" || selected.objectType === "IDX-Segment" || selected.objectType === "Pipeline-Segment") {
            let tagId;
            for (const child of props.items) {
                if (child.objectType === "IDX-Tag" && child.children?.length) {
                    const idsUnderTag = getAllIds(child);
                    if (idsUnderTag.includes(selected.id)) {
                        tagId = child.id;
                        break;
                    }
                }
            }
            setTagId(tagId);
        }
    },[])

    // const CustomStartDateInput = (props) => {
    //     return (
    //         <>
    //             <DateInput {...props} format="yyyy-MM-dd" placeholder="YYYY-MM-DD"
    //                        label={<span className={"required-asterisk"}>Start Date</span>}/>
    //         </>
    //     )
    // };
    //
    // const CustomEndDateInput = (props) => {
    //     return (
    //         <>
    //             <DateInput {...props} format="yyyy-MM-dd" placeholder="YYYY-MM-DD" label={"End Date"} />
    //         </>
    //     )
    // };
    useEffect(() => {

    }, [disableSubmit]);
    // function validateDates(startDate, endDate) {
    //     console.log(startDate);
    //     let startYear;
    //     let startMonth;
    //     let startDay;
    //     let endYear;
    //     let endMonth;
    //     let endDay;
    //
    //     if (!(startDate instanceof Date) || isNaN(startDate)) {
    //         setConsumerDatesWarningMsg("Start date is invalid.");
    //         return false;
    //     }
    //
    //     // Extract date parts
    //     if(startDate){
    //          startYear = startDate.getFullYear();
    //          startMonth = startDate.getMonth() + 1; // getMonth() is zero-based
    //          startDay = startDate.getDate();
    //     }
    //     if(endDate){
    //         endYear = endDate.getFullYear();
    //         endMonth = endDate.getMonth() + 1;
    //         endDay = endDate.getDate();
    //     }
    //     // Check if any date part is zero
    //     if (startYear === 0 || startMonth === 0 || startDay === 0) {
    //         dateRangeStyle = "invalid-date-range";
    //         setConsumerDatesWarningMsg("Start date cannot have a zero year, month, or day.");
    //         return false;
    //     }
    //     if (endYear === 0 || endMonth === 0 || endDay === 0) {
    //         dateRangeStyle = "invalid-date-range";
    //         setConsumerDatesWarningMsg("End date cannot have a zero year, month, or day.");
    //         return false;
    //     }
    //     // Ensure startDate is earlier than endDate
    //     if (startDate >= endDate && endDate !== null) {
    //         setConsumerDatesWarningMsg("Start date must be earlier than end date.");
    //         return false;
    //     }
    //
    //     setConsumerDatesWarningMsg("");
    //     return true;
    // }
    // const onDatesChange = (e) => {
    //     let startDateString = "";
    //     let endDateString = "";
    //     const startDate = e.value.start;
    //     const endDate = e.value.end;
    //     // console.log("startDate", startDate)
    //     // console.log("endDate", endDate)
    //     if(startDate){
    //         if(validateDates(startDate,endDate)){
    //             const startYear = String(startDate.getFullYear()).padStart(4, '0')
    //             const startMonth = String(startDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    //             const startDay = String(startDate.getDate()).padStart(2, '0');
    //             startDateString = `${startYear}-${startMonth}-${startDay}`;
    //             setStartDate(startDateString);
    //             setDisableSubmit(false);
    //         }else{
    //             setDisableSubmit(true);
    //         }
    //     }else{
    //             setConsumerDatesWarningMsg("Start Date is not valid.");
    //             setStartDate(null);
    //             setDisableSubmit(true);
    //     }
    //     if(endDate){
    //         if(validateDates(startDate,endDate)){
    //             const endYear = String(endDate.getFullYear()).padStart(4, '0')
    //             const endMonth = String(endDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    //             const endDay = String(endDate.getDate()).padStart(2, '0');
    //             endDateString = `${endYear}-${endMonth}-${endDay}`;
    //             setEndDate(endDateString);
    //             setDisableSubmit(false);
    //         }else{
    //             setDisableSubmit(true);
    //         }
    //     }else{
    //         setEndDate(null);
    //     }
    // };

    const connections = allSavedSettings?.map((item, i) => {
        if (allSavedSettings.length > 0) {
            return (
                {text: item.connection_name, id: item.id, protocol: item.transfer_protocol}
            )
        } else {
            return (
                {text: "No Saved Connections", id: 0}
            )
        }
    });

    const scopes = [
        {text: "All", id: "A"},
        {text: "Consumer", id: "C"},
        {text: "Business", id: "B"}
    ];

    const handleConnectionChange = (e) => {
        console.log(e.value);
        const setting = allSavedSettings.filter(ftpSetting => ftpSetting.id === e.value.id);
        setConnection(setting[0]);
        setCurrentConnection({
            ...currentConnection,
            ['text']: e.value.text,
            ['id']: e.value.id
        });
        setFtpSettingsId(e.value.id);
    };

    const handleScopeChange = (e) => {
        console.log(e.value);
        setCurrentScope({
            ...currentScope,
            ['text']: e.value.text,
            ['id']: e.value.id
        });
    };

    const identityReport = async () => {
        setDisableSubmit(true);
        let tempId;
        let finalStartDate;
        let finalEndDate;
        if(dateStartValue){
            finalStartDate = formatDateToString(dateStartValue);
        }else{
            finalStartDate = "";
        }
        if(dateEndValue){
            finalEndDate = formatDateToString(dateEndValue);
        }else{
            finalEndDate = null;
        }
        try {
            if(selectedSegment.objectType.toLowerCase()  !== 'idx-tag'){
                tempId = selectedSegment.id;
            }else {
                tempId = null;
            }
            const payload = {
                segmentId: tempId,
                idxTagId: tagId,
                start_date: finalStartDate,
                end_date: finalEndDate,
                ftpsettings_id: currentConnection.id,
                scope: currentScope.id
            };
            console.log(payload)
            let response = await semcastAxios.post(IDENTITY_REPORT_IDX_PIXEL_API,
                payload,
                {withCredentials: true})
                .then(async (res) => {
                    // console.log("identity report res:", res);
                    if (res.data.status === SUCCESS_STATUS) {
                        showSuccessToastMessage("Identity Report Request Sent Successfully.");
                        // FD: 10863 (reversal of 10839)
                        props.reloadAfterIdentity();
                        setVisible(false);
                    }
                });
        } catch (error) {
            console.log(error)
            showErrorToastMessage(error.response.data.data);
            setDisableSubmit(false);
            // props.reloadAfterIdentity();
        }
    }

    useEffect(() => {
        //pre-fill with createdAt as start date, recommended
        let defaultStart;
          if( props.Identity.profileFormik){
              defaultStart = new Date(props.Identity.profileFormik.values.selectedSegments[0].createdAt);
          }else{
              defaultStart = null;
          }
          setDateStartValue(defaultStart);
      //   let fixedStart;
      //   if( props.Identity.profileFormik){
      //       fixedStart = new Date(props.Identity.profileFormik.values.selectedSegments[0].createdAt);
      //   }else{
      //       fixedStart = null;
      //   }
      // setDateRangeValue([fixedStart,null])
    }, []);


    // const handleRSuiteDateChange = (e) =>{
    //     console.log(e)
    //     setDateRangeValue(e)
    // }
    // const handleRSuiteDateSelect = (e) =>{
    //     console.log(dateRangeValue)
    //     if(dateRangeValue && dateRangeValue[0]){
    //         setDateRangeValue([dateRangeValue[0],e])
    //     }
    //
    // }
    const handleRSuiteDateStartChange = (e) => {
        setDateStartValue(e);
    }
    const handleRSuiteDateEndChange = (e) => {
        setDateEndValue(e);
    }

    useEffect(() => {
        if(dateEndValue !== null && dateStartValue !== null && dateStartValue > dateEndValue){
            setConsumerDatesWarningMsg("End date cannot be earlier than start date.");
            setDisableSubmit(true);
        }
        if(dateStartValue !== null && dateStartValue < dateEndValue){
            setConsumerDatesWarningMsg("");
            setDisableSubmit(false);
        }
        if(dateStartValue !== null && dateEndValue === null){
            setConsumerDatesWarningMsg("");
            setDisableSubmit(false);
        }
        if(dateStartValue === null){
            setConsumerDatesWarningMsg("Start date is required");
            setDisableSubmit(true);
        }
    }, [dateStartValue, dateEndValue]);

    return (
        <>
            <div id="identityReport">
                {visible && (
                    <Dialog
                        title={"Identity Report For IDX - "+props.segName}
                        width={630}
                        height={550}
                        closeIcon={false}
                        className={"dialog-standard"}
                    >
                        {/*<div className="col-xl-12 col-xxl-12 col-lg-12 col-md-12 col-sm-12">*/}
                        <div className={"identity-controls-content"}>
                            {/*<div className="form-group">*/}
                            <div className={"center"}>
                                <div style={{display: "flex",flexDirection:"row"}}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div>
                                            <Label className={"identity-connection-label required-asterisk"}>Start Date</Label>
                                        </div>
                                        <DatePicker
                                            id={"date-start"}
                                            format={"MM/dd/yyyy"}
                                            container={() => dateStartRef.current}
                                            value={dateStartValue}
                                            onChange={e => handleRSuiteDateStartChange(e)}
                                        />
                                        <div style={{height: "auto"}} ref={dateStartRef}></div>
                                    </div>
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div>
                                            <Label className={"identity-connection-label"}>End Date</Label>
                                        </div>
                                        <DatePicker
                                            id={"date-end"}
                                            format={"MM/dd/yyyy"}
                                            container={() => dateEndRef.current}
                                            value={dateEndValue}
                                            onChange={e => handleRSuiteDateEndChange(e)}
                                        />
                                        <div style={{height: "auto"}} ref={dateEndRef}></div>
                                    </div>

                                </div>
                                <Label className={"invalid-date-range"} >{consumerDatesWarningMsg}</Label>
                                {/*<DateRangePicker*/}
                                {/*    format={"MM/dd/yyyy"}*/}
                                {/*    container={() => dateRangeRef.current}//set dropdown calendar anchor point*/}
                                {/*    value={dateRangeValue}*/}
                                {/*    onChange={e => handleRSuiteDateChange(e)}*/}
                                {/*    onSelect={e => handleRSuiteDateSelect(e)}*/}
                                {/*    className="rsuite-date-range-picker"*/}
                                {/*    id={"date-range-picker"}*/}
                                {/*/>*/}
                                {/*<div style={{height: "auto"}} ref={dateRangeRef}></div>*/}
                            </div>

                            {/*<DateRangePicker*/}
                            {/*    // startDateInput={CustomStartDateInput}*/}
                            {/*    // endDateInput={CustomEndDateInput}*/}
                            {/*    startDateInputSettings={{*/}
                            {/*        format: 'MM/dd/yyyy',*/}
                            {/*        label:"Start Date",*/}
                            {/*        id:"start-date"*/}
                            {/*    }}*/}
                            {/*    endDateInputSettings={{*/}
                            {/*        format: 'MM/dd/yyyy',*/}
                            {/*        label:"End Date",*/}
                            {/*        id:"end-date"*/}
                            {/*    }}*/}
                                {/*    onChange={onDatesChange}*/}
                                {/*    className={"identity-date-picker"}*/}
                                {/*    defaultValue={{start: defaultStartDate, end: null}}*/}
                                {/*    show={false}*/}
                                {/*/>*/}
                                {/*<Label className={"invalid-date-range"}>{consumerDatesWarningMsg}</Label>*/}
                            {/*</div>*/}
                            <div className={"center"}>
                            <div>
                            <Label className={"identity-connection-label required-asterisk"}>Save To
                                    Connection</Label>
                            </div>
                            <div>
                                {isLoaded ? (
                                    <DropDownList
                                        data={connections}
                                        // itemRender={itemRender}
                                        textField="text"
                                        dataItemKey="id"
                                        onChange={(e) => handleConnectionChange(e)}
                                        value={currentConnection}
                                        fillMode={"outline"}
                                        className="identity-connection-settings"
                                        disabled={allSavedSettings.length === 0}
                                        style={{fontSize: "14px"}}
                                    />
                                ) : (
                                    <Loader height={"100%"}/>
                                )}
                            </div>
                            </div>
                            <br/>
                            <div className={"center"}>
                            <div>
                                <Label className={"identity-connection-label required-asterisk"}>Scope</Label>
                            </div>
                            <div>
                                <DropDownList
                                    data={scopes}
                                    textField="text"
                                    dataItemKey="id"
                                    onChange={(e) => handleScopeChange(e)}
                                    value={currentScope}
                                    fillMode={"outline"}
                                    disabled={selectedSegment.objectType.toLowerCase() !== "idx-tag" ? 'disabled' : ''}
                                    className={`identity-scope ${selectedSegment.objectType.toLowerCase() !== "idx-tag" ? 'disabled' : ''}`}
                                    style={{fontSize: "14px"}}
                                />
                            </div>
                            </div>
                            <br/>
                        </div>
                        <DialogActionsBar layout={"end"}>
                            <Button
                                // className="dialog-cancel"
                                className={"button-standard button-white"}
                                onClick={() => {
                                    props.cancelSubscriber(undefined)
                                }}>
                                Cancel
                            </Button>
                            <Button
                                disabled={disableSubmit}
                                className={"button-standard button-submit"}
                                onClick={identityReport}>
                                Submit
                            </Button>
                        </DialogActionsBar>
                    </Dialog>)}
            </div>
        </>
    );
}

export default IdentityActivation;
